import { baseApi } from "@/shared/api";

export interface NationalHoliday {
  id: number;
  month: number;
  day: number;
  name_ru: string;
  name_kk: string;
}

interface CreateNationalHolidayDto {
  month: number;
  day: number;
  name_ru: string;
  name_kk: string;
}

interface UpdateNationalHolidayDto extends CreateNationalHolidayDto {
  id: number;
}

export const nationalHolidaysApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNationalHolidays: builder.query<NationalHoliday[], void>({
      query: () => ({
        url: "/api/accounting/national-holidays/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "Holidays" as const, id: "LIST" }],
    }),

    createNationalHoliday: builder.mutation<NationalHoliday, CreateNationalHolidayDto>({
      query: (body) => ({
        url: "/api/accounting/national-holidays/",
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Holidays" as const, id: "LIST" }],
    }),

    updateNationalHoliday: builder.mutation<NationalHoliday, UpdateNationalHolidayDto>({
      query: ({ id, ...body }) => ({
        url: `/api/accounting/national-holidays/${id}/`,
        method: "PUT",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Holidays" as const, id: "LIST" }],
    }),

    deleteNationalHoliday: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/accounting/national-holidays/${id}/`,
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Holidays" as const, id: "LIST" }],
    }),
  }),
});

export const {
  useGetNationalHolidaysQuery,
  useCreateNationalHolidayMutation,
  useUpdateNationalHolidayMutation,
  useDeleteNationalHolidayMutation,
} = nationalHolidaysApi;
